interface VatDeclarationRowLabelProps {
    label: string;
    subLabel?: string;
    isTotal?: boolean;
    onViewContributions?: () => void;
    contributionCount?: number;
}

export function VatDeclarationRowLabel({
    label,
    subLabel,
    isTotal = false,
    onViewContributions,
    contributionCount,
}: VatDeclarationRowLabelProps) {
    return (
        <div className="col-span-6 flex flex-col pr-2.5">
            <button
                type="button"
                onClick={onViewContributions}
                disabled={!onViewContributions}
                className={[
                    "text-left",
                    onViewContributions ? "hover:cursor-pointer" : "cursor-default",
                    "disabled:opacity-100 disabled:pointer-events-none",
                ].join(" ")}
            >
                <div className="flex items-center gap-2">
                    <span
                        className={`block text-sm ${isTotal ? "font-semibold" : ""} text-gray-900 leading-tight ${
                            onViewContributions ? "transition-colors hover:text-primary hover:underline" : ""
                        }`}
                    >
                        {label}
                    </span>
                    {typeof contributionCount === "number" && contributionCount > 0 && (
                        <span className="text-xs text-gray-400">({contributionCount})</span>
                    )}
                </div>
                {subLabel && <p className="text-sm text-gray-500 mt-0.5">{subLabel}</p>}
            </button>
        </div>
    );
}
